import { WorkflowDetails } from 'axiosApi/models/workflow-details';

/**
 * Returns true if the given workflow state allows editing for the current user.
 *
 * - editable:        user has an edit scope granted by the workflow config
 * - editableByOwner: user is the item owner (scope "0")
 *
 * When the state is not found in the workflow (e.g. workflow still loading,
 * or stateId is null/undefined) the function returns false — treat unknown
 * states as read-only to be safe.
 *
 * @param workflow   The WorkflowDetails object from useWorkflow()
 * @param stateId    The current idWorkflowState of the entity
 * @param isOwner    Whether the current user owns the entity (default false)
 */
export function isWorkflowStateEditable(
  workflow: WorkflowDetails | null | undefined,
  stateId: number | null | undefined,
  isOwner = false
): boolean {
  if (!workflow || stateId == null) return false;
  const state = workflow.states?.find((s) => s.id === stateId);
  if (!state) return false;
  return state.editable === true || (isOwner && state.editableByOwner === true);
}

/**
 * Inverse of isWorkflowStateEditable — returns true when the form should be
 * rendered read-only. This is the value you pass directly to a `disabled` prop.
 */
export function isWorkflowStateReadOnly(
  workflow: WorkflowDetails | null | undefined,
  stateId: number | null | undefined,
  isOwner = false
): boolean {
  return !isWorkflowStateEditable(workflow, stateId, isOwner);
}
